import { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
import { COMMENTS_HTML_ID } from './Comments';
export function useScrollToDeviationComments() {
    const isMobile = useContext(MobileContext);
    return useCallback(()=>{
        const commentsSectionStart = document.getElementById(COMMENTS_HTML_ID);
        commentsSectionStart && scrollIntoViewWithHeader(commentsSectionStart, isMobile, 0, undefined, false, true // skipVisibilityCheck
        );
    }, [
        isMobile
    ]);
}
